"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsAgreeFitProtocalRequest = void 0;
var IsAgreeFitProtocalRequest = /** @class */ (function () {
    function IsAgreeFitProtocalRequest() {
    }
    return IsAgreeFitProtocalRequest;
}());
exports.IsAgreeFitProtocalRequest = IsAgreeFitProtocalRequest;
//# sourceMappingURL=isAgreeFitProtocal.request.js.map